import { toast } from '@/hooks'
import { useFoldersStore } from '../../stores'
import type { Folder } from '../../stores/types'

export const archiveFolder = (folder: Folder) =>
  useFoldersStore
    .getState()
    .mutations.archiveFolder(folder.slug)
    .then(
      () => toast({ title: 'Folder archived', theme: 'success' }),
      (error: Error) =>
        toast({
          title: "We couldn't archive this folder",
          description: error.message,
          theme: 'destructive',
        }),
    )
